import { FormikInput } from 'shared/components/FormikInput'

import { NameSettings } from '../model/generalData'
import { useFormikContext } from 'formik'
import { AreaNameSettingsWrapper } from './style'

interface AreaNameSettingsProps {
    isEditable: boolean
}

export function AreaNameSettings({ isEditable }: AreaNameSettingsProps) {
    const { values } = useFormikContext<any>()

    return (
        <AreaNameSettingsWrapper>
            <FormikInput
                required={NameSettings.required}
                name={NameSettings.name}
                label={NameSettings.label}
                placeholder={NameSettings.placeholder}
                type={NameSettings.type}
                disabled={!isEditable || (NameSettings.disabled ?? false)}
                value={values[NameSettings.name]}
                className='inputForm'
                $afterIcon='clearInput'
            />
        </AreaNameSettingsWrapper>
    )
}
